// extracted by mini-css-extract-plugin
module.exports = {"permissionForm__wrap":"PermissionForm_permissionForm__wrap__2nZWt","permissionForm__row":"PermissionForm_permissionForm__row__1tzp8"};